module.exports = __webpack_public_path__ + "static/world-5a6a0d4570860333519060173938fba5.jpg";